// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overview-locations-list{align-items:flex-start;display:flex;flex:1 0 0;flex-direction:column;gap:16px}", ""]);
// Exports
module.exports = exports;
